import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";
import { useAppSelector } from "./redux/hooks";
import Loader from "./common/Loader";
import { customerRoutes, loginRoutes, sellerRoutes } from "./routes";
import useFetchOrgId from "./hooks/FetchOrgId";
import { initGA, logPageView } from "./ga";

const AppLoginRouter: React.FC = () => {
  return (
    <Routes>
      {loginRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={<route.element />} />
      ))}
    </Routes>
  );
};

const AppRouter: React.FC = () => {
  const loading = useAppSelector((state) => state.app.loading);
  const location = useLocation();
  useFetchOrgId();

  useEffect(() => {
    initGA(); // Initialize only once on mount
  }, []);

  useEffect(() => {
    logPageView(location.pathname + location.search); // Track every route change
  }, [location]);

  return (
    <>
      <Loader show={loading} />
      <Routes>
        {/* Public Routes */}
        <Route path="/*" element={<AppLoginRouter />} />
        <Route path="/:orgId/*" element={<AppLoginRouter />} />

        {/* Customer Routes */}
        <Route
          path="/:orgId/customer/*"
          element={
            <AppLayout>
              <Routes>
                {customerRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <ProtectedRoute>
                        <route.element />
                      </ProtectedRoute>
                    }
                  />
                ))}
              </Routes>
            </AppLayout>
          }
        />

        {/* Seller Routes */}
        <Route
          path="/:orgId/seller/*"
          element={
            <AppLayout>
              <Routes>
                {sellerRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <ProtectedRoute>
                        <route.element />
                      </ProtectedRoute>
                    }
                  />
                ))}
              </Routes>
            </AppLayout>
          }
        />
      </Routes>
    </>
  );
};

export default AppRouter;
